N2.ready(() => {
  N2.handle("click", "[data-toggle='toast']", function(e) {
    let opts = {
      action: $(this).data("toast-action"),
      text: $(this).data("toast-text"),
    }

    toastr.options["positionClass"] = "toast-bottom-center";
    if (opts.action) {
      let ele = $("<a>" + opts.action + "</a>");

      toastr.options["actionLink"] = ele;
    }

    toastr.info(opts.text);
  });

  N2.handle("click", "input[data-auto-switch-off=true]", function(e) {
    $(this).attr('checked', false);
  });
})
